<template>
  <div id="app">
    <div id="nav">
      <u-loader v-if="!$store.state.loaded"></u-loader>
      <!-- <router-link to="/">Home</router-link>|
      <router-link to="/about">About</router-link>-->
      <app-navigationbar :key="$route.fullPath"></app-navigationbar>
    </div>
    <router-view class="routerView" :key="$route.fullPath" />
    <app-Footer></app-Footer>
  </div>
</template>
<script>
import Navigationbar from '../src/components/navigationbar.vue'
import Footer from '../src/components/footer.vue'
export default {
  components: {
    appNavigationbar: Navigationbar,
    appFooter: Footer,
  },
  name: 'App',
  data: () => {
    return {}
  },
}
</script>
<style lang="scss">
@import './assets/css/style.css';
@import './assets/css/variables.css';
@import './assets/css/classroom.css';
/*@import "./assets/sass/style.scss";*/
// @import "./assets/scss/style.scss";
.cr_form_input,
.btn registration_next {
  background-color: transparent;
}
#app {
  min-height: 100vh;
  position: relative;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}
* {
  margin: 0px;
  padding: 0px;
  border: 0px;
  box-sizing: border-box;
}
.hover {
  cursor: pointer;
}

.hover-link:hover {
  cursor: pointer;
  color: #00ffa6;
}
.cardover {
  max-width: 401px;
}

.cardover:hover {
  box-shadow: 0px 15px 30px #0136861a;
  opacity: 0.98;
  cursor: pointer;
}
.new-col11 a {
  color: white !important;
}

.cardover a:first-child {
  color: #000000;
}

.ualert {
  box-sizing: border-box;
  background-color: #bdffe1;
  width: 100%;
  position: relative;
  text-align: center;
  top: 0;
  left: 0;
  z-index: 300;
  /*padding: 20px 40px;*/
  color: #333;
}

.ualert h2 {
  font-size: 16px;
  color: #232323;
  margin-top: 0;
}

.ualert p {
  line-height: 1.6em;
  font-size: 12px;
  margin: 0;
}

.ualert a {
  color: #232323;
  font-weight: bold;
}

// code for updated slider
.tns-outer {
  padding: 0 !important;
}
.tns-outer button {
  display: none;
}

.tns-outer [hidden] {
  display: none !important;
}

.tns-outer [aria-controls],
.tns-outer [data-action] {
  cursor: pointer;
}

.tns-slider {
  -webkit-transition: all 0s;
  -moz-transition: all 0s;
  transition: all 0s;
}

.tns-slider > .tns-item {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.tns-horizontal.tns-subpixel {
  white-space: nowrap;
}

.tns-horizontal.tns-subpixel > .tns-item {
  display: inline-block;
  vertical-align: top;
  white-space: normal;
}

.tns-horizontal.tns-no-subpixel:after {
  content: '';
  display: table;
  clear: both;
}

.tns-horizontal.tns-no-subpixel > .tns-item {
  float: left;
}

.tns-horizontal.tns-carousel.tns-no-subpixel > .tns-item {
  margin-right: -100%;
}

.tns-no-calc {
  position: relative;
  left: 0;
}

.tns-gallery {
  position: relative;
  left: 0;
  min-height: 1px;
}

.tns-gallery > .tns-item {
  position: absolute;
  left: -100%;
  -webkit-transition: transform 0s, opacity 0s;
  -moz-transition: transform 0s, opacity 0s;
  transition: transform 0s, opacity 0s;
}

.tns-gallery > .tns-slide-active {
  position: relative;
  left: auto !important;
}

.tns-gallery > .tns-moving {
  -webkit-transition: all 0.25s;
  -moz-transition: all 0.25s;
  transition: all 0.25s;
}

.tns-autowidth {
  display: inline-block;
}

.tns-lazy-img {
  -webkit-transition: opacity 0.6s;
  -moz-transition: opacity 0.6s;
  transition: opacity 0.6s;
  opacity: 0.6;
}

.tns-lazy-img.tns-complete {
  opacity: 1;
}

.tns-ah {
  -webkit-transition: height 0s;
  -moz-transition: height 0s;
  transition: height 0s;
}

.tns-ovh {
  overflow: hidden;
}

.tns-visually-hidden {
  display: none;
  position: absolute;
  left: -10000em;
}

.tns-transparent {
  opacity: 0;
  visibility: hidden;
}

.tns-fadeIn {
  opacity: 1;
  filter: alpha(opacity=100);
  z-index: 0;
}

.tns-normal,
.tns-fadeOut {
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.tns-vpfix {
  white-space: nowrap;
}

.tns-vpfix > div,
.tns-vpfix > li {
  display: inline-block;
}

.tns-t-subp2 {
  margin: 0 auto;
  width: 310px;
  position: relative;
  height: 10px;
  overflow: hidden;
}

.tns-t-ct {
  width: 2333.3333333%;
  width: -webkit-calc(100% * 70 / 3);
  width: -moz-calc(100% * 70 / 3);
  width: calc(100% * 70 / 3);
  position: absolute;
  right: 0;
}
.tns-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  padding: 0 50px;
  padding-bottom: 30px;
}
.tns-controls button {
  display: block;
}
.tns-t-ct:after {
  content: '';
  display: table;
  clear: both;
}
.tns-visually-hidden {
  display: none !important;
}
#tns1-ou {
  display: none;
}
.tns-t-ct > div {
  width: 1.4285714%;
  width: -webkit-calc(100% / 70);
  width: -moz-calc(100% / 70);
  width: calc(100% / 70);
  height: 10px;
  float: left;
}
.tns-controls button {
  display: none;
  position: relative;
  width: 65px;
  height: 65px;
  background-color: transparent;
  border-radius: 50%;
  border: none;
  font-size: 0;
  background-repeat: no-repeat;
  background-position: center center;
  transition-property: background-color;
  transition-duration: 300ms;
}

.tns-controls button:nth-child(1) {
  display: block;
  left: 0;
  background-image: url('./assets/homeV2/Icon material-arrow_back.svg');
}

.tns-controls button:nth-child(2) {
  display: block;
  right: 0;
  background-image: url('./assets/homeV2/Icon material-arrow-forward.svg');
}
@media only screen and (max-width: 600px) {
  .tns-controls button {
    display: none !important;
  }
}
.error-alert {
  background-color: #f8d7da !important;
  border: 1px solid #721c24 !important;
}
.error-alert-text {
  // color: whitesmoke !important;
  color: #721c24 !important;
  font-weight: bold !important;
}
.success-alert {
  background-color: #d4edda !important;
  border: 1px solid #155724 !important;
  color: #155724 !important;
}
.success-alert-text {
  // color: whitesmoke !important;
  color: #155724 !important;
  font-weight: bold !important;
}
</style>
